import React from "react";
import classes from "./BurgerIngredient.module.css";

function Chicken() {
  return <div className={classes.Chicken}></div>;
}

export default Chicken;
